module.exports = __webpack_public_path__ + "img/3.96e4efcc.jpg";